import { Link } from 'react-router-dom';
import PortalLayout from '@/components/feature/PortalLayout';
import { usePageMeta } from '@/hooks/usePageMeta';

export default function AboutPage() {
  usePageMeta({
    title: '关于我们 - 诱人的女员工hd影视专区',
    description:
      '了解诱人的女员工hd影视专区的定位与内容范围：我们专注影视作品介绍与推荐，为用户整理最新电影电视剧的剧情介绍、演员资料与相关资讯。',
    keywords: '诱人的女员工hd,关于我们,影视专区,剧情介绍,演员信息',
  });

  return (
    <PortalLayout>
      <div className="max-w-4xl mx-auto px-4 md:px-8 py-8">
        <nav className="flex items-center gap-1 text-xs text-foreground-500 mb-5">
          <Link to="/" className="hover:text-accent-600 cursor-pointer">首页</Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-foreground-700">关于我们</span>
        </nav>

        <h1 className="font-heading font-black text-2xl md:text-3xl text-foreground-950">关于我们</h1>
        <p className="mt-3 text-sm md:text-base text-foreground-700 leading-relaxed">
          诱人的女员工hd影视专区是一个专注影视作品介绍与推荐的资讯门户。我们围绕「诱人的女员工hd」相关主题，
          为喜爱电影与电视剧的观众整理作品信息，帮助大家在浩如烟海的影视资源中，更快地了解剧情、演员与相关资讯，
          从而挑选出真正想看的作品。
        </p>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-4">
          {[
            { icon: 'ri-movie-2-line', title: '作品库', desc: '持续收录最新电影与热播剧集，信息完整清晰' },
            { icon: 'ri-user-star-line', title: '演员资料', desc: '整理主创与演员信息，快速了解作品阵容' },
            { icon: 'ri-search-eye-line', title: '便捷查找', desc: '支持搜索、多条件筛选与排序，查找更高效' },
          ].map((item) => (
            <div key={item.title} className="bg-background-100 border border-background-200 rounded-lg p-5">
              <span className="inline-flex w-11 h-11 items-center justify-center rounded-lg bg-accent-100 text-accent-700 mb-3">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <h2 className="font-heading font-bold text-foreground-950">{item.title}</h2>
              <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <section className="mt-10">
          <h2 className="font-heading font-black text-xl text-foreground-950 mb-3">联系方式</h2>
          <div className="bg-background-100 border border-background-200 rounded-lg p-5 space-y-3 text-sm text-foreground-700">
            <p className="flex items-center gap-2">
              <span className="w-6 h-6 flex items-center justify-center text-accent-600"><i className="ri-mail-line"></i></span>
              意见反馈邮箱：contact@yrhd-media.example
            </p>
            <p className="flex items-center gap-2">
              <span className="w-6 h-6 flex items-center justify-center text-accent-600"><i className="ri-time-line"></i></span>
              服务时间：工作日 09:00 – 18:00
            </p>
            <p className="text-xs text-foreground-500">
              以上联系方式仅用于演示，本站暂不提供在线留言功能，如需反馈可在正式上线后通过邮件联系。
            </p>
          </div>
        </section>

        <section className="mt-8">
          <h2 className="font-heading font-black text-xl text-foreground-950 mb-3">使用声明</h2>
          <div className="bg-background-100 border border-background-200 rounded-lg p-5 space-y-3 text-sm text-foreground-700 leading-relaxed">
            <p>本站所有内容均围绕影视作品的介绍与推荐展开，仅用于资讯展示与信息整理，不提供在线播放、下载等任何形式的内容分发服务。</p>
            <p>站内影视海报、剧照等素材用于页面视觉演示，作品信息以实际情况为准。若相关内容涉及版权问题，请通过上方邮箱与我们联系处理。</p>
            <p>用户在浏览本站时产生的收藏等数据仅保存在本地浏览器中，不会上传或用于其他用途。</p>
          </div>
        </section>

        <div className="mt-8 flex flex-wrap gap-3">
          <Link to="/category/movie" className="px-5 py-2.5 rounded-md bg-accent-500 text-background-50 text-sm font-medium hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer">
            去看电影
          </Link>
          <Link to="/category/tv" className="px-5 py-2.5 rounded-md border border-background-300 text-foreground-800 text-sm font-medium hover:border-accent-400 hover:text-accent-600 transition-colors whitespace-nowrap cursor-pointer">
            去看电视剧
          </Link>
        </div>
      </div>
    </PortalLayout>
  );
}